import React, { useMemo, useReducer } from "react";

import PropTypes from "prop-types";

const EmployeeRowsContext = React.createContext();

const counterReducer = (state, action) => {
    switch (action.type) {
      case 'increment': {
        return {count: state.count + 1}
      }
      case 'decrement': {
        return {count: state.count - 1}
      }
      default: {
        throw new Error(`Unhandled action type: ${action.type}`)
      }
    }
};

export const EmployeeRowsProvider = (props) => {
    const [employeesInProgress, setEmployeesInProgress] = useReducer(counterReducer, { count: 0});

    const contextValue = useMemo(() => ({
        employeesInProgress,
        setEmployeesInProgress,
    }), [employeesInProgress]);

    return (
        <EmployeeRowsContext.Provider value={contextValue}>
            {props.children}
        </EmployeeRowsContext.Provider>
    );
};

EmployeeRowsProvider.propTypes = {
    children: PropTypes.node
};

export default EmployeeRowsContext;
